exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".inventory {\n  margin-right: 10px;\n  width: 250px;\n  line-height: 28px; }\n  .inventory .first-tree-link {\n    margin-left: 20px; }\n\n.inventory-tree .tree {\n  width: auto !important;\n  max-width: none !important; }\n\n.inventory-add-org {\n  position: relative;\n  width: 100%;\n  bottom: 0px;\n  opacity: 1; }\n  .inventory-add-org div {\n    bottom: 0px;\n    padding: 10px;\n    margin-bottom: 20px;\n    border-top: 1px solid #CCC;\n    border-bottom: 1px solid #CCC;\n    text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/inventory-main/inventory.scss
// module id = Bl3I
// module chunks = 0